/* eslint-disable @typescript-eslint/no-explicit-any */
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { success, error } from '@/libs/notification';
import { getBaseUrl } from '@/libs/env';
import { getAccessToken } from '@/libs/firebaseAuth';
import router from '@/router';
import {
  SupplierDataState,
  SupplierSubmitData,
  SuppliersState,
  SupplierReplaceData
} from '@/types/master/supplier';
import { ElLoading } from 'element-plus';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    listData: []
  },
  mutations: {
    setList(state: SuppliersState, payload: SupplierDataState[]) {
      state.listData = payload;
    },
    setReplace(state: SuppliersState, payload: SupplierReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(`${getBaseUrl()}/master/suppliers`, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setList', response.data);
          const replaceData: SupplierReplaceData = {};
          response.data.forEach((data: SupplierDataState) => {
            replaceData[data.id] = data.name;
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async submit(context: any, payload: SupplierSubmitData) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .post(`${getBaseUrl()}/master/suppliers`, payload, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('Success', '仕入先登録に成功しました。');
          router.push('/master/supplier');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
